export default __webpack_public_path__ + "static/media/holiday.94d5132a.svg";